import { createEvent } from 'effector';
import { Notification } from '.';

export const loadNotificationsEV = createEvent<Notification[]>();

export const pushNotificationEV = createEvent<Notification>();
